/**
 * P2 Pre-Live Checklist API client (Stage 1, read-only).
 */
import { apiFetch } from '../utils/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export type ChecklistStatus =
  | 'pass'
  | 'ready'
  | 'warn'
  | 'fail'
  | 'unknown'
  | 'manual'
  | 'skip';

export interface ChecklistItem {
  key: string;
  section: string;
  label: string;
  status: ChecklistStatus;
  actual: string | null;
  note: string | null;
}

export interface ChecklistSummary {
  total: number;
  counts: Record<ChecklistStatus, number>;
  blocking: boolean;
}

export interface ChecklistResponse {
  generated_at: string;
  summary: ChecklistSummary;
  items: ChecklistItem[];
}

export async function fetchChecklistStatus(): Promise<ChecklistResponse> {
  const url = `${API_BASE_URL}/api/checklist/status`;
  const response = await apiFetch(url);
  if (!response.ok) {
    throw new Error(`체크리스트 조회 실패: ${response.status}`);
  }
  return response.json();
}
